import type { PreOnboardingContextType } from '@/context/escript/PreOnboardingContext';
import { PreOnboardingContext } from '@/context/escript/PreOnboardingContext';
import { useContext } from 'react';

export const usePreOnboardingContext = (): PreOnboardingContextType => {
  const context = useContext(PreOnboardingContext);
  if (!context) {
    throw new Error('usePreOnboardingContext must be used within the PreOnboarding provider');
  }
  return context;
};
